import {GET_ONE_MANAGEMENT_START} from "../../types";

export const get_one_management = (payload) => ({
    type: GET_ONE_MANAGEMENT_START,
    payload,
});